require('./components/dataLayer.js');
require('./components/nav.js');
require('./components/scroll.js');
require('./components/onpageNavigation.js');
require('./components/mapBoxStoryTelling.js');
